import { useEffect, useState } from "react";
import { submitEvaluation } from "../../api/Evaluation";
import "./styles.css";
import { fetchEventByRef } from "../../api/Event";

const months = ["January","February","March","April","May","June","July",
  "August","September","October","November","December"];

const Evaluation = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const [refLink, setRefLink] = useState("");
  const eventRef = urlParams.get('eventRef');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [eventDetails, setEventDetails] = useState();

  useEffect(() => {
    setRefLink(urlParams.get('refId'));
  }, []);

  const loadEventDetails = async (ref) => {
    const res = await fetchEventByRef(ref);

    if (res) {
      const date = new Date(res.end_date);
      const formattedDate = `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;

      setEventDetails({
        id: res.id,
        date: formattedDate,
        name: res.name,
      });
    }
  }

  useEffect(() => {
    if (!eventRef) return;

    loadEventDetails(eventRef);
  }, [eventRef]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const formData = new FormData(event.currentTarget);

    const entries = [...formData.entries()];

    let obj = {};

    entries.forEach(([key, value]) => {
      obj = {
        ...obj,
        [key]: value,
      };
    });

    const jsonObj = JSON.stringify(obj)

    const res = await submitEvaluation({ refId: refLink, answers: jsonObj });

    setSubmitted(true);
  }
  return (!!refLink && eventDetails) && (
    <div className="evaluation__wrapper">
      <form onSubmit={handleSubmit}>
      <div className="wrapper">
        <div className="card">
          <div className="card-header"></div>
          <div className="card-body">
            <h3 className="card-title">Event Evaluation Form</h3>
            <span className="exam--date">{eventDetails.date}</span>
          </div>
          <hr />
          <div className="card-body form--comment">
             {eventDetails.name}
          </div>
        </div>
      </div>

      {!submitted && (
        <div className="wrapper client--question-form">

        <div class="card" data-question="${qi}">
          <div class="card-body">
            <p class="question-label">
              Overall, how do you rate the event?
            </p>
            <br />
            <div class="answers-container">
              <table>
                <thead>
                  <tr>
                    <td></td>
                    <td className="text-center">1</td>
                    <td className="text-center">2</td>
                    <td className="text-center">3</td>
                    <td className="text-center">4</td>
                    <td className="text-center">5</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-right">Very poor</td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="rate" value="1" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="rate" value="2" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="rate" value="3" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="rate" value="4" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="rate" value="5" />
                    </td>
                    <td>Excellent</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card" data-question="${qi}">
          <div class="card-body">
            <p class="question-label">
            Please rate your satisfaction with the content of the webinar by indicating your level of agreement or disagreement with each of the following statements.
            </p>
            <br />
            <div class="answers-container" style={{ overflowX: "scroll"}}>
              <table>
                <thead>
                  <tr>
                    <td></td>
                    <td className="text-center">Strongly Disagree</td>
                    <td className="text-center">Disagree</td>
                    <td className="text-center">Neutral</td>
                    <td className="text-center">Agree</td>
                    <td className="text-center">Strongly Agree</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      The session delivered the information I expected to receive.
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-1" value="1" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-1" value="2" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-1" value="3" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-1" value="4" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-1" value="5" />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      The subject matter was presented effectively.
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-2" value="1" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-2" value="2" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-2" value="3" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-2" value="4" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-2" value="5" />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      The pace of the event was satisfactory.
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-3" value="1" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-3" value="2" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-3" value="3" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-3" value="4" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-3" value="5" />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      The duration of the event was sufficient for the material covered.
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-4" value="1" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-4" value="2" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-4" value="3" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-4" value="4" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-4" value="5" />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      The resource speakers were knowledgeable.
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-5" value="1" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-5" value="2" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-5" value="3" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-5" value="4" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-5" value="5" />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      As a result of this event, I gained new knowledge applicable to my professional development.
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-6" value="1" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-6" value="2" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-6" value="3" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-6" value="4" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-6" value="5" />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      I plan to apply what I learned in this event.
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-7" value="1" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-7" value="2" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-7" value="3" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-7" value="4" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-7" value="5" />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      Event like this is  effective way for me and my colleagues to obtain information and training.
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-8" value="1" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-8" value="2" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-8" value="3" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-8" value="4" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-8" value="5" />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      The presenters responded to questions.
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-9" value="1" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-9" value="2" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-9" value="3" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-9" value="4" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-9" value="5" />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      I would recommend others to join future events by Petrosphere and its partner(s).
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-10" value="1" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-10" value="2" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-10" value="3" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-10" value="4" />
                    </td>
                    <td className="text-center">
                      <input required type="radio" class="answer--input" id="rate" name="satifactory-10" value="5" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card" data-question="${qi}">
          <div class="card-body">
            <p class="question-label">
            What did you like MOST about the event?
            </p>
            <br />
            <div class="answers-container">
              <input required type="text" name="like-most" placeholder="Answer" />
            </div>
          </div>
        </div>

        <div class="card" data-question="${qi}">
          <div class="card-body">
            <p class="question-label">
            What did you like LEAST about the event?
            </p>
            <br />
            <div class="answers-container">
              <input required type="text" name="like-least" placeholder="Answer" />
            </div>
          </div>
        </div>

        <div class="card" data-question="${qi}">
          <div class="card-body">
            <p class="question-label">
            Suggest a future topic for event you would like to attend.
            </p>
            <br />
            <div class="answers-container">
              <input required type="text" name="suggest" placeholder="Answer" />
            </div>
          </div>
        </div>

        <div class="card" data-question="${qi}">
          <div class="card-body">
            <p class="question-label">
            Do you have any additional comments about the webinar?
            </p>
            <br />
            <div class="answers-container">
              <input required type="text" name="comments" placeholder="Answer" />
            </div>
          </div>
        </div>

        <div class="card" data-question="${qi}">
          <div class="card-body">
            <p class="question-label">
              I am interested in attending future events offered by Petrosphere and its partner(s). Please include me in the mailing list.
            </p>
            <br />
            <div class="answers-container">
              <div class="answer">
                <input required type="radio" class="answer--input" id="yes" name="interested" value="yes" />
                <label for="yes">Yes</label>
              </div>
              <div class="answer">
                <input required type="radio" class="answer--input" id="no" name="interested" value="no" />
                <label for="no">No</label>
              </div>
            </div>
          </div>
        </div>

      </div>
      )}

      {submitted && (
        <div className="wrapper client--summary-form">
          <div className="card">
            <div className="card-body">
              <div className="summary-logo">
                <img src="http://petros-global.com/uploads/logo/certificate.png" />
                <p>
                  <span className="text-success">Congratulations!</span> You have
                  successfully submitted your evaluation!
                </p>
                <p>
                  You may check your email to access your digital certificate.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {!loading && !submitted && (
        <div className="wrapper">
          <div className="config-container">
            <button type="submit" className="btn btn-primary btn--submit">
              Submit
            </button>

            <button type="button" className="btn btn--clear d-none">Clear Form</button>
            <button type="button" className="btn btn--show-summary d-none">
              Show Exam Summary
            </button>
          </div>
        </div>
      )}
      </form>
    </div>
  )
};

export default Evaluation;